import { CustomTable } from 'common/components/table/customTable';
import {
  SortingState,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable
} from '@tanstack/react-table';
import { getPathsColumnDefs } from './paths-column-defs';
import { FC, useMemo, useState } from 'react';
import { ConversionPath } from '../paths.models';
import { CustomTablePaging } from 'common/components/table/tableTypes';
import { useSelector, useDispatch } from 'react-redux';
import {
  onNextPage,
  onPageSizeChanged,
  onPreviousPage,
  selectPathsTableState
} from '../paths.slice';
import { DropDownItemType } from 'common/components/drop-downs/legacy/dropDownItemType';
import { Pagination } from 'common/components/pagination/pagination';
import { selectCurrencyCode } from 'features/settings/settingsSlice';

interface ConversionPathsTableProps {
  conversionPaths: ConversionPath[];
}

export const PathsTable: FC<ConversionPathsTableProps> = ({
  conversionPaths
}) => {
  const dispatch = useDispatch();
  const currencyCode = useSelector(selectCurrencyCode);
  const [sorting, setSorting] = useState<SortingState>([]);
  const columnDefs = getPathsColumnDefs(currencyCode);

  const pathsTableState = useSelector(selectPathsTableState);

  const pathsTable = useReactTable({
    data: conversionPaths,
    columns: columnDefs,
    state: {
      sorting,
      pagination: {
        pageIndex: pathsTableState.currentPage - 1, // TanStack uses a zero-based index for paging
        pageSize: pathsTableState.currentPageSize
      }
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    enableColumnResizing: true,
    debugTable: false,
    debugHeaders: false,
    debugColumns: false
  });
  const numberOfTableRows = pathsTable.getFilteredRowModel().rows.length;

  const paging = useMemo(() => {
    const paging: CustomTablePaging = {
      isSticky: true,
      currentPage: pathsTableState.currentPage,
      currentPageSize: pathsTableState.currentPageSize,
      pageSizes: pathsTableState.pageSizes.map<DropDownItemType>((pageSize) => {
        const pageSizeString = pageSize.toString();
        return {
          key: pageSizeString,
          label: pageSizeString,
          isActive: pageSize === pathsTableState.currentPageSize
        };
      }),
      totalRecords: numberOfTableRows
    };

    return paging;
  }, [pathsTableState, numberOfTableRows]);
  return (
    <>
      <CustomTable
        key={'paths-table'}
        componentId={'paths-table'}
        table={pathsTable}
        overflowClass="max-sm:overflow-auto"
      />
      <Pagination
        currentPage={paging.currentPage}
        currentPageSize={paging.currentPageSize}
        totalPages={pathsTable.getPageCount()}
        totalRecords={paging.totalRecords}
        pageSizes={paging.pageSizes}
        isSticky={paging.isSticky}
        onPreviousPage={() => dispatch(onPreviousPage())}
        onNextPage={() => dispatch(onNextPage())}
        onPageSizeChanged={(pagesize) => dispatch(onPageSizeChanged(pagesize))}
      ></Pagination>
    </>
  );
};
export default PathsTable;
